import { useContext, useMemo } from "react"
import PropTypes from "prop-types"
import ListItemDropDown from "components/list-item-dropdown"
import { METRIC_OPTIONS } from "helpers/metrics/definitions"
import { useAnalytics } from "connected-components/analytics"
import { FACTORS_VIEW_EVENTS } from "../../analytics/events"
import PeriodDisplay from "connected-components/dashboard/components/period-display"
import { PERFORMANCE_CONTEXT } from "./context"

export default function PerformanceHeader({ context }) {
  const { selectedMetricDisplay, setSelectedMetricDisplay } = useContext(PERFORMANCE_CONTEXT)
  const analytics = useAnalytics()

  const metricOptions = useMemo(() => METRIC_OPTIONS.factorPerformance.map(({ id, label }) => ({ id, primaryText: label })), [])

  const handleDisplayMetricChange = (metricDisplay) => {
    analytics.track(FACTORS_VIEW_EVENTS.DISPLAY_METRIC_SELECTED, { metricDisplay })
    setSelectedMetricDisplay(metricDisplay)
  }

  return <>
    <PeriodDisplay context={context} />
    <ListItemDropDown
      label="Display"
      value={selectedMetricDisplay}
      setValue={handleDisplayMetricChange}
      options={metricOptions}
      alignMenu="left"
      disablePortal
    />
  </>
}

PerformanceHeader.propTypes = {
  context: PropTypes.object.isRequired,
}
